var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"serviceRankingList-rules"}},[_c('img',{attrs:{"src":`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/rule1${_vm.$route.query.currentJobTab}.jpg`,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }